import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { hasRole } from "../lib/rbac";

export function ProtectedRoute({ children, allowedRoles }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-screen flex items-center justify-center text-[color:var(--asl-muted)]"
            >
                Loading…
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    if (allowedRoles && !hasRole(user, ...allowedRoles)) {
        return <Navigate to="/forbidden" replace />;
    }
    return children;
}
